import { DocumentStatus } from 'services/documents/entities';

export const statusColors: Record<DocumentStatus, string> = {
  [DocumentStatus.DRAFT]: '#E1F3FF',
  [DocumentStatus.SENT]: '#DFF9FF',
  [DocumentStatus.VIEWED]: '#EADDFF',
  [DocumentStatus.AWAITING_SIGNATURE]: '#FCDEEC',
  [DocumentStatus.WON]: '#CFFAE4',
  [DocumentStatus.LOST]: '#FFDADB',
  [DocumentStatus.AWAITING_APPROVAL]: '#FFFBE1',
  [DocumentStatus.APPROVED]: '#E1F3FF',
};
